<p-card>
  <div class="row">
    <div class="col-12 mb-3">
      <h1 class="main-title" style="margin-top: 0px">Renda-shboard</h1>
      <p class="text-color-secondary"></p>
    </div>
  </div>

  <div class="col-12 cards-numbers-container" style="padding: 0px">
    <div class="dashboard-card" (click)="navigateToLease()" style="cursor: pointer">
      <div class="card-content">
        <div class="icon-container-blue">
          <i class="fa-solid fa-building card-icon-blue"></i>
        </div>
        <h2 *ngIf="dataLoaded; else skeletonLeases">{{ leasesCount }}</h2>
        <ng-template #skeletonLeases>
          <p-skeleton width="180px" height="30px" class="skeletons"></p-skeleton>
        </ng-template>
        <p>Arrendamientos</p>
      </div>
    </div>

    <div class="dashboard-card" (click)="navigateToWallet()" style="cursor: pointer">
      <div class="card-content">
        <div class="icon-container-green">
          <i class="fa-solid fa-wallet card-icon-green"></i>
        </div>
        <h2 *ngIf="dataLoaded; else skeletonWallet">${{ walletAmount | number: '1.2-2' }}</h2>
        <ng-template #skeletonWallet>
          <p-skeleton width="180px" height="30px" class="skeletons"></p-skeleton>
        </ng-template>
        <p>Valor cartera</p>
      </div>
    </div>

    <div class="dashboard-card" (click)="navigateToWallet()" style="cursor: pointer">
      <div class="card-content">
        <div class="icon-container-rose">
          <i class="fa-solid fa-coins card-icon-rose"></i>
        </div>
        <h2 *ngIf="dataLoaded; else skeletonWalletWithoutAccesories">${{ walletAmountWithoutAccesories | number: '1.2-2' }}</h2>
        <ng-template #skeletonWalletWithoutAccesories>
          <p-skeleton width="180px" height="30px" class="skeletons"></p-skeleton>
        </ng-template>
        <p>Valor cartera sin accesorios</p>
      </div>
    </div>

    <div class="dashboard-card" (click)="navigateToWallet()" style="cursor: pointer">
      <div class="card-content">
        <div class="icon-container-purple">
          <i class="fa-solid fa-land-mine-on card-icon-purple"></i>
        </div>
        <h2 *ngIf="dataLoaded; else skeletonResiduary">${{ residuary | number: '1.2-2' }}</h2>
        <ng-template #skeletonResiduary>
          <p-skeleton width="180px" height="30px" class="skeletons"></p-skeleton>
        </ng-template>
        <p>Residual general</p>
      </div>
    </div>

    <!-- ADR-0032 · Fase E7 — telemetría de magic links CIEC.
           Solo visible para roles internos con clients.get-all; los demás reciben 403
           y la tarjeta muestra "—" (degradación elegante). -->
    <div class="dashboard-card" style="cursor: default">
      <div class="card-content">
        <div class="icon-container-blue">
          <i class="fa-solid fa-shield-halved card-icon-blue"></i>
        </div>
        <h2 *ngIf="dataLoaded; else skeletonCiec">{{ ciecConversionLabel }}</h2>
        <ng-template #skeletonCiec>
          <p-skeleton width="180px" height="30px" class="skeletons"></p-skeleton>
        </ng-template>
        <p data-test="ciec-ratio">
          {{ ciecRatioLabel }}<ng-container *ngIf="ciecIssuesLabel"> · {{ ciecIssuesLabel }}</ng-container>
        </p>
      </div>
    </div>
  </div>

  <div class="col-12 flex charts-container">
    <div class="card-style chart-wrapper" (click)="navigateToActive()" style="cursor: pointer">
      <app-assets></app-assets>
    </div>

    <div class="card-style chart-wrapper" (click)="navigateToPayment()" style="cursor: pointer">
      <app-monthly-target></app-monthly-target>
    </div>

    <div class="card-style chart-wrapper" (click)="navigateToLease()" style="cursor: pointer">
      <app-new-leases></app-new-leases>
    </div>
  </div>

  <div style="margin-top: 15px">
    <app-pending-balances></app-pending-balances>
  </div>

  <div style="margin-top: 21px">
    <app-monthly-balances></app-monthly-balances>
  </div>
</p-card>
